export enum ObjectTypes {
    Unknown = 0,
    User = 1,
    Role = 2,
    BusinessUnit = 3,
    Area = 4,
    BusinessArea = 5,
    Cluster = 6,
    Document = 8,
    Tag = 9,
    ExtendedRoleRight = 10,
    ExtendedAccessRoleRight = 11,
    ContentLanguage = 12,
    ApplicationLanguageLabel = 13,
    PreferredBusinessUnit = 14,
    Country = 15,
    Post = 16,
    MediaBank = 17,
    Template = 18,
    Widget = 19,
    Contact = 20,
    History = 21,
    Addresses = 22,
    Agreement = 24,
    Likes = 26,
    Comment = 27,
    FirstPage = 28,
    SideBar = 29,
    Invoice = 31,
    CreditCard = 32,
    WidgetPlaceHolderControl = 33,
    WidgetModuleContent = 34,
    WebmailAccount = 35,
    SMSMessage = 36,
    BillingPaymentInfo = 37,
    BillingPriceArticle = 38,
    Currency = 39,
    OtherBillingCustomer = 40,
    CheckList = 41,
    CheckPoint = 42,
    CheckPointAnswer = 43,
    SiteMap = 45,
    Forum = 46,
    ForumPost = 47,
    CheckListReport = 48,
    CheckListPeriod = 50,
    CheckPointAnswerNotification = 51,
    CheckListTemplate = 52,
    DataFieldGroup = 53,
    DataField = 54,
    Notification = 55,
    DataFieldPreSetOption = 56,
    MediaBankGrouped = 57,
    CustomerSetting = 58,
    CheckListActivated = 59,
    CheckListReminder = 60,
    OtherSettings = 61,
    ListViewSettings = 62,
    Statistic2 = 63,
    Form = 64,
    FormQuestion = 65,
    FormPresetOption = 66,
    FormReminder = 67,
    FormAnswerSet = 68,
    Task = 69,
    TaskReminder = 70,
    TaskRequestAssistance = 71,
    TaskCompleted = 72,
    TaskDeadlineReminder = 73,
    FormAnswer = 74,
    ChatConversation = 75,
    ChatConversationMessage = 76,
    WidgetAdministrate = 77,

    Checklist2 = 79,
    Checkpoint2 = 80,
    CheckpointGroup = 81,
    ChecklistSchedule = 82,
    ChecklistToSchedule = 83,
    Checkpoint2Answer = 84,
    Checklist2Report = 86,

    Checklist2Audit = 87,
    Checklist2AuditTemplate = 88,
    Checklist2AuditSchedule = 89,
    Checklist2AuditReport = 90,
    ChecklistToAuditSchedule = 91,
    Checkpoint2Audit = 92,

    PKImportLog = 97,

    UserAccessRequest = 99,
    NewsFeed = 100,
    BalooSyncLog = 101,
    PKSettings = 102,

    Checklist2Template = 111,
    Task2 = 112,
    Task2Reports = 113,

    TodoList = 114,
    TodoSection = 115,
    TodoItem = 116,

    Quiz = 117,
    QuizQuestion = 118,
    QuizQuestionPresetOption = 119,

    Onboarding = 120,
    OnboardingSection = 121,
    OnboardingStep = 122,
    OnboardingStepCompletion = 123,
    TodoItemCompletion = 124,

    OnboardingReport = 125,

    CustomFranchiseIntranetUpgrade = 900,
    CustomerBillingCustomer = 901,
    CustomerBillingInvoice = 902,
    CustomerBillingReseller = 903,

    CustomFranchiseIntranetUpgradeLogoutWarning = 203,
}
